import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { useIntl } from "react-intl";

import "./McpServerDetailsPage.scss";
import ChatbotLayout from "../../chatbot/shared/ChatbotLayout";
import Message from "../../../i18n/Message";
import {
  CableIcon,
  ChevronLeftIcon,
  PlugIcon,
  PlusIcon,
  UnplugIcon,
} from "lucide-react";
import Spinner from "../../../assets/icons/Spinner";
import ZeroState from "../../chatbot/shared/ZeroState";
import { mcpServerSelectors } from "../store/mcpServerReducer";
import { linkToMcpServers } from "../../../routes";
import { loadPublicMcpServers } from "../store/mcpServerActionCreators";

const McpServerDetailsPage = () => {
  const { serverId, tabId } = useParams();
  const intl = useIntl();
  const nav = useNavigate();
  const dispatch = useDispatch();
  const servers = useSelector(mcpServerSelectors.getPublicServers);
  const [tab, setTab] = useState(tabId);

  useEffect(() => {
    dispatch(loadPublicMcpServers(intl));
  }, [intl, dispatch]);

  const server = servers?.find((item) => item.uid === serverId);

  if (servers && !server) {
    return (
      <ChatbotLayout contentPanelClassName="mcp_server_details_page">
        <div className="title_row">
          <div className="title_column">
            <div className="breadcrumbs">
              <div onClick={() => nav(linkToMcpServers())}>
                <ChevronLeftIcon
                  size={16}
                  strokeWidth="2"
                  color="rgb(103, 116, 142)"
                />
                <Message id="back_to_mcp_servers" />
              </div>
            </div>
          </div>
        </div>
        <div className="error_body">Server not found</div>
      </ChatbotLayout>
    );
  }

  if (server) {
    return (
      <ChatbotLayout contentPanelClassName="mcp_server_details_page">
        <div className="title_row">
          <div className="breadcrumbs">
            <div onClick={() => nav(linkToMcpServers())}>
              <ChevronLeftIcon
                size={16}
                strokeWidth="2"
                color="rgb(103, 116, 142)"
              />
              <Message id="back_to_mcp_servers" />
            </div>
          </div>
          <div className="title_section">
            <div className="icon_container">
              <div className="icon_circle">
                <UnplugIcon size={24} color="#67748e" />
              </div>
            </div>
            <div className="title_column">
              <div className="title_value">{server.name}</div>
              <div className="slug" title={server.slug}>
                {server.slug}
              </div>
            </div>
          </div>
        </div>
        <div className="server_content_container card">
          <div className="left_side_container">
            <div className="left_side_body">
              <div className="section_title">
                <Message id="mcp_server_section_about" />
              </div>
              <div className="description">{server.description}</div>
            </div>
          </div>
          <div className="right_side_container">
            <div className="right_side_body">
              <div className="connect_title_row">
                <div className="connect_icon">
                  <PlugIcon color="#67748e" size={18} />
                </div>
                <div className="section_title">
                  <Message id="mcp_server_section_connect" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </ChatbotLayout>
    );
  } else {
    return null;
  }
};

export default McpServerDetailsPage;
